import React, {useEffect, useState} from 'react'
import Cookies from 'js-cookie';

function Option({mpesa, options, form}) {

  const [password, setPassword] = useState()
  const [cookie, setCookie] = useState();


  useEffect(()=>{
  
    const userCookie = Cookies.get('user');
    if (userCookie) {
     
        
        setCookie(userCookie)
  
    }
  
  },[cookie])

  const go = () =>
  {
   

    if(password)
    {
      

 
             // Send data to the PHP backend using fetch
             fetch('https://hosteladventures.site/PHP/Check_password.php', {
               method: 'POST',
               headers: {
                 'Content-Type': 'application/json'
               },
               body: JSON.stringify({
                passwords: password,
               })
             })
               .then(response => response.json())
               .then(data => {
                 // Handle response from backend (e.g., login success or failure)
                 if(data.message=='proceed')
                 {
                  form(true)
                  mpesa(false)
                  options(false)
                 }

                 else{
                  alert('Invalid Password')
                 }
              
               })
               .catch(error => {
                 console.error('Error:', error);
               });
    }

    else
    {
      alert('please fill password!!')
    }
    
  }

  const mpesa_BTN = () =>
  {
    //mpesa(true)
    //options(false)
    //form(false)

    alert('Payment Coming Soon, Please create password in student form.')
  }
  return (
    <div className='OPT_INNER'>
  
      <div>
      <p className='fill_In'>Fill In</p>
        <div className='inp_FLEX'>
        <input placeholder='Add Student Password.' type='password'   onChange={(event) => setPassword(event.target.value)}  /> 
        <button className='goBtn' onClick={go}>Go</button>
        <p className='OR'>or</p>
        <button className='goBtn' onClick={mpesa_BTN}>Pay Ksh.300 to Acess this Part</button> 
        </div>
        
      </div>

    </div>
  )
}

export default Option